import {ChangeDetectionStrategy, Component, effect, inject, input, signal} from '@angular/core';
import {LineChartDataParams, LineChartDialogData, UpdateLineChartParams} from "../../types/line-chart-modal.types";
import {LineChartModalService} from "../../services/line-chart-modal.service";
import {ChartConfiguration, ChartData, ChartType} from "chart.js";
import {defaultLineChart, optionLineChat} from "../../configs/line-chart-config";
import {LineChartWeekService} from "../../services/line-chart-week.service";
import {BaseChartDirective} from "ng2-charts";
import {ErrorService} from "../../../../../services/error.service";

@Component({
  selector: 'app-line-chart-week',
  standalone: true,
  imports: [
    BaseChartDirective
  ],
  templateUrl: './line-chart-week.component.html',
  styleUrl: './line-chart-week.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LineChartWeekComponent {
  lineChartDialogData = input.required<LineChartDialogData>();
  updateLineChartParams = input.required<UpdateLineChartParams>();
  isArticlePage = input<boolean>(false);

  private lineChartModalService: LineChartModalService = inject(LineChartModalService);
  private lineChartWeekService: LineChartWeekService = inject(LineChartWeekService);
  private errorService: ErrorService = inject(ErrorService);

  public lineChartData = signal<ChartData<'line'>>(defaultLineChart);
  public lineChartOptions = signal<ChartConfiguration['options']>(optionLineChat);
  public lineChartType = signal<ChartType>('line');

  private updateChartEffect = effect(async () => {
    const params = this.updateLineChartParams();
    await this.updateChart(params);
  });

  public getNoDataMessage(): string {
    return `Выберите ${ this.isArticlePage() ? 'артикул' : 'продукт' }, период и колонки`;
  }

  private async updateChart(updateLineChartParams: UpdateLineChartParams): Promise<void> {
    const { selectedProductId, selectedArticleId, rangeData, selectedColumns } = updateLineChartParams;
    const { dateFrom, dateTo } = rangeData;

    if ((!selectedProductId && !selectedArticleId) || !dateFrom || !dateTo || !selectedColumns?.length) {
      this.lineChartData().datasets = [];
      return;
    }

    await this.getLineChartData();

    if (!this.lineChartDialogData().recordsTableData.length) {
      this.errorService.showErrorMessage('Нет данных по выбранным параметрам в фильтрах');
      this.lineChartData().datasets = [];
      return;
    }

    const columnsSelectData = this.lineChartModalService.getColumnsSelectData(this.lineChartDialogData().fields);

    this.lineChartData.set({
      labels: this.lineChartDialogData().recordsTableData.map(item => item['dateFrom']),
      datasets: selectedColumns.map((metric, index) =>
        this.lineChartModalService.getDatasetConfig({
          key: metric,
          data: this.lineChartDialogData().recordsTableData.map(item => item[metric] as number),
          columnsSelectData: columnsSelectData,
          index: index
        })
      )
    });
  }

  private async getLineChartData(): Promise<void> {
    const lineChartDataParams: LineChartDataParams = this.lineChartWeekService.setLineChartDataParams(this.updateLineChartParams(), this.lineChartDialogData().parentUrl);
    this.lineChartDialogData().recordsTableData = await this.lineChartModalService.getLineChartData(lineChartDataParams).catch(() => []);
  }
}
